// /* eslint-disable @typescript-eslint/no-unused-vars */
// /* eslint-disable jsx-a11y/anchor-is-valid */
// /* eslint-disable react-hooks/exhaustive-deps */
// import { useEffect, useState } from "react";
// import {
//   IconBox,
//   IconBuilding,
//   IconBuildingCastle,
//   IconBuildingStore,
//   IconBuildingWarehouse,
//   IconCalendar,
//   IconCalendarClock,
//   IconChecks,
//   IconCloudDown,
//   IconContract,
//   IconCopy,
//   IconEdit,
//   IconFlag,
//   IconHome2,
//   IconId,
//   IconKey,
//   IconMail,
//   IconMapPin,
//   IconPhone,
//   IconReportAnalytics,
//   IconShoppingCartCopy,
//   IconUserCheck,
//   IconX,
// } from "@tabler/icons-react";

// import {
//   useStaffDetailsData,
//   useStaffUpdateMutation,
// } from "../../../apis/staffApis";

// import NewCommonModal from "../../../components/common/NewCommonModal";
// import AddStaffModal from "./AddStaffModal";
// import { useForm } from "react-hook-form";
// import formatDate, { maskedSecretKey } from "../../../utilities/helper";
// import toast from "react-hot-toast";
// import { usePermission } from "../../../hooks/usePermissionTabs";
// import NoDataFound from "../../../components/common/NoDataFound";
// import NormalSearch from "../../../components/common/NormalSearch";
// import AddMerchantModal from "./AddMerchantModal";
// import {
//   useFetchMerchantSingleData,
//   useMerchantUpdateMutation,
// } from "../../../apis/merchantApis";
// import { useSalesAllIntegrationData } from "../../../apis/integrationApis";
// import { use3PLListData } from "../../../apis/3plApis";

// type Props = {
//   id: string;
//   open: boolean;
//   onClose: () => void;
//   refetchList?: () => void;
// };

// type FormValues = {
//   id?: string;
//   name: string;
//   mobileNo: string;
//   email: string;
//   clientId?: string;
//   secretKey?: string;
//   contactType: string;
//   vatNumber: string;
//   nationalId: string;
//   nationalCopy: string;
//   crNumber: string;
//   warehouse: string;
//   contactPerson: string;
//   district: string;
//   city: string;
//   paymentTerm: string;
//   access: string;
//   clientType: string;
//   location: string;
//   status?: string;
//   contractDate: Date;
//   vatDocument: File | undefined;
//   companyLogo: File | undefined;
//   crCopy: File | undefined;
//   contractDocument: File | undefined;
// };

// const titleColors: Record<string, string> = {
//   "Workplace Details": "text-orange-600",
//   Documents: "text-green-600",
//   Channels: "text-purple-600",
//   Location: "text-blue-600",
//   "Warehouse Location": "text-blue-600",
//   "Merchant Office Location": "text-amber-600",
// };

// const InfoBlock = ({
//   title,
//   children,
//   className,
// }: {
//   title: string;
//   children: React.ReactNode;
//   className?: string;
// }) => (
//   <div>
//     <h4
//       className={`text-sm font-semibold text-[#212121] mb-2 uppercase tracking-wide ${
//         titleColors[title] || "text-gray-600"
//       } `}
//     >
//       {title}
//     </h4>
//     <div className={` ${className || "space-y-2"}`}>{children}</div>
//   </div>
// );

// const Row = ({
//   icon,
//   label,
//   value,
//   icon2,
//   className,
//   onClick,
// }: {
//   icon?: React.ReactNode;
//   icon2?: React.ReactNode;
//   label: string;
//   className?: string;
//   value: React.ReactNode;
//   onClick?: () => void;
// }) => (
//   <div
//     onClick={onClick}
//     className={`flex items-center  gap-2   text-gray-700 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] rounded-lg px-3 py-2 border border-[#D2D2D2] ${
//       onClick ? "cursor-pointer hover:bg-[#F4F1E6] px-2 py-1 rounded-md" : ""
//     } ${className}`}
//   >
//     {icon && <div className="mt-0.5 text-gray-500">{icon}</div>}
//     <div>
//       <span className="font-medium text-sm text-[#212121]">{label}: </span>
//       <span className="break-all text-xs">{value || ""}</span>
//     </div>
//     {icon2 && <div className="mt-0.5 text-gray-500">{icon2}</div>}
//   </div>
// );

// export default function ViewMerchantModal({ id, open, onClose, refetchList }: Props) {
//   const {
//     data: merchantData,
//     refetch: fetchMerchantData,
//     isFetching,
//   } = useFetchMerchantSingleData(id);
//   const [copied, setCopied] = useState(false);
//   const { mutate, isPending } = useMerchantUpdateMutation(merchantData?.id);
//   const [channelModal, setChannelModal] = useState<"sales" | "shipping" | null>(
//     null,
//   );
//   const { data: salesChannels } = useSalesAllIntegrationData();
//   const { data: shippingChannels } = use3PLListData();

//   const [selectedDocument, setSelectedDocument] = useState<any>({
//     crCopy: false,
//     companyLogo: false,
//     vatDocument: false,
//     contractDocument: false,
//     nationalCopy: false,
//   });
//   const [permissionModal, setPermissionModal] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [editDialog, setEditDialog] = useState(false);
//   const [allIds, setAllIds] = useState<any>();

//   const { allowed: canUpdateClient, isLoading } = usePermission(
//     "clients",
//     "update",
//   );

//   const {
//     register,
//     handleSubmit,
//     setValue,
//     watch,
//     clearErrors,
//     control,
//     reset,
//     formState: { errors },
//   } = useForm<any>();

//   useEffect(() => {
//     if (open && id) {
//       fetchMerchantData();
//     }
//   }, [open, id]);

//   useEffect(() => {
//     if (editDialog && merchantData) {
//       reset(merchantData);
//     }
//   }, [editDialog, merchantData]);

//   const getIds = (data: any) => {
//     setAllIds(data);
//   };

//   const [credential, setCredential] = useState<boolean>(false);
//   const credentialToggleModal = () => {
//     setCredential(!credential);
//     if (!credential) {
//       reset();
//     }
//   };

//   const handleUpdate = (data: FormValues) => {
//     let {
//       clientId,
//       secretKey,
//       crCopy,
//       companyLogo,
//       contractDocument,
//       vatDocument,
//       nationalCopy,
//       ...otherData
//     } = data;

//     mutate(
//       {
//         ...otherData,
//         ...(selectedDocument?.crCopy && { crCopy: crCopy }),
//         ...(selectedDocument?.vatDocument && { vatDocument: vatDocument }),
//         ...(watch("vatDocument") && { vatDocumentAvailabel: true }),
//         ...(watch("nationalCopy") && { NationalIdAvailabel: true }),
//         ...(watch("crCopy") && { crCopyAvailabel: true }),
//         ...(watch("contractDocument") && { contractDocumentAvailabel: true }),
//         ...(selectedDocument?.companyLogo && { companyLogo: companyLogo }),
//         ...(selectedDocument?.nationalCopy && { nationalCopy: nationalCopy }),
//         ...(selectedDocument?.contractDocument && {
//           contractDocument: contractDocument,
//         }),
//         ...allIds,
//       },
//       {
//         onSuccess: () => {
//           setSelectedDocument({
//             crCopy: false,
//             companyLogo: false,
//             vatDocument: false,
//             contractDocument: false,
//             nationalCopy: false,
//           });
//           credentialToggleModal();
//           setEditDialog(false);
//           fetchMerchantData();
//           refetchList?.();
//           toast.success("Merchant Update successfully!");
//         },
//         onError: (error: any) => {
//           const errorMessage =
//             error?.response?.data?.error?.message ||
//             error?.response?.data?.message ||
//             error?.message ||
//             (typeof error === "string" ? error : null) ||
//             "Failed to Update Merchant";

//           toast.error(errorMessage);
//         },
//       },
//     );
//   };

//   const handleCopy = async (text?: string) => {
//     if (!text) return;

//     try {
//       await navigator.clipboard.writeText(text);
//       setCopied(true);

//       setTimeout(() => {
//         setCopied(false);
//       }, 1500);
//     } catch (err) {
//       console.error("Copy failed", err);
//     }
//   };

//   const smartEmail = (email?: string) => {
//     if (!email) return "";

//     const [name, domain] = email.split("@");
//     if (!domain) return email;

//     const [domainName, extension] = domain.split(".");

//     const shortName = name.length > 5 ? `${name.slice(0, 4)}...` : name;

//     const shortDomain =
//       domainName && domainName.length > 4
//         ? `${domainName.slice(0, 3)}...`
//         : domainName;

//     return `${shortName}@${shortDomain}.${extension || ""}`;
//   };

//   return (
//     <>
//       <NewCommonModal
//         title={editDialog ? "Edit Merchant" : "Merchant Details"}
//         open={open}
//         onClose={() => {
//           setEditDialog(false);
//           onClose();
//         }}
//         closeButtonText="Close"
//         actionButtonText={
//           editDialog ? (
//             "Update"
//           ) : canUpdateClient ? (
//             <IconEdit size={18} />
//           ) : undefined
//         }
//         actionButtonOnClick={
//           editDialog
//             ? handleSubmit(handleUpdate)
//             : canUpdateClient
//               ? () => setEditDialog(true)
//               : undefined
//         }
//         isPending={isPending}
//       >
//         {isFetching ? (
//           <div className="w-full space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
//             <div className="h-[calc(100vh-10rem)] overflow-y-auto space-y-4 pt-0 p-4 px-6 scrollbar-clean">
//               <div className="p-10 text-center">Loading...</div>
//             </div>
//           </div>
//         ) : editDialog ? (
//           <AddMerchantModal
//             register={register}
//             errors={errors}
//             clearErrors={clearErrors}
//             setValue={setValue}
//             control={control}
//             getIds={getIds}
//             watch={watch}
//             setSelectedDocument={setSelectedDocument}
//             merchantData={merchantData}
//           />
//         ) : (
//           <div className="w-full space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
//             <div className="flex gap-6 py-4 h-[calc(100vh-10rem)] px-6">
//               <div className="w-[300px] relative bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-white/40 shadow-xl rounded-3xl p-6 flex flex-col items-center">
//                 <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />

//                 <div className="relative">
//                   <div className="w-40 h-40 rounded-full p-[4px] bg-gradient-to-tr from-yellow-400 to-orange-300 shadow-lg">
//                     <div className="w-full h-full rounded-full overflow-hidden bg-white">
//                       <img
//                         src={merchantData?.companyLogo || "/img/dummy-logo.png"}
//                         alt="Comapny Logo"
//                         className="w-full h-full object-cover"
//                       />
//                     </div>
//                   </div>

//                   <span
//                     className={`absolute -bottom-2 left-1/2 -translate-x-1/2 px-3 py-1 text-xs rounded-full shadow ${
//                       merchantData?.status === "ACTIVE"
//                         ? "bg-green-100 text-green-700"
//                         : "bg-red-100 text-red-600"
//                     }`}
//                   >
//                     {merchantData?.status}
//                   </span>
//                 </div>
//                 <div className="space-y-2 mt-4 ">
//                   <h2 className="text-center text-xl font-semibold text-gray-800">
//                     {merchantData?.name}
//                   </h2>
//                   <Row
//                     icon={<IconId size={18} />}
//                     label="Merchant Id"
//                     value={merchantData?.clientId}
//                   />
//                   <Row
//                     icon={<IconPhone size={18} />}
//                     label="Mobile"
//                     value={merchantData?.mobileNo}
//                   />

//                   <Row
//                     icon={<IconKey size={18} />}
//                     label="Secret Key"
//                     value={maskedSecretKey(merchantData?.secretKey)}
//                     icon2={
//                       <div
//                         onClick={() => handleCopy(merchantData?.secretKey)}
//                         className="cursor-pointer relative"
//                       >
//                         {copied ? (
//                           <span className="text-xs text-green-600 font-medium">
//                             <IconChecks size={18} />
//                           </span>
//                         ) : (
//                           <IconCopy size={18} />
//                         )}
//                       </div>
//                     }
//                   />
//                   <Row
//                     icon={<IconMail size={18} />}
//                     label="Mail"
//                     value={smartEmail(merchantData?.email)}
//                     icon2={
//                       <div
//                         onClick={() => handleCopy(merchantData?.email)}
//                         className="cursor-pointer relative"
//                       >
//                         {copied ? (
//                           <span className="text-xs text-green-600 font-medium">
//                             <IconChecks size={18} />
//                           </span>
//                         ) : (
//                           <IconCopy size={18} />
//                         )}
//                       </div>
//                     }
//                   />

//                   <Row
//                     icon={<IconCalendar size={18} />}
//                     label="Joined"
//                     value={formatDate(merchantData?.createdAt)}
//                   />

//                   <div
//                     onClick={() => setPermissionModal(true)}
//                     className="  cursor-pointer"
//                   >
//                     <Row
//                       icon={<IconUserCheck size={18} />}
//                       label="Access"
//                       value={merchantData?.access}
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div className="flex-1 overflow-y-auto overflow-hidden pr-2  scrollbar-clean space-y-5">
//                 <InfoBlock title="Workplace Details">
//                   <Row
//                     icon={<IconBuilding size={18} />}
//                     label="Warehouse"
//                     value={merchantData?.warehouseName}
//                   />
//                   <Row
//                     icon={<IconContract size={18} />}
//                     label="Contact Person"
//                     value={merchantData?.contactPerson ?? ""}
//                   />
//                   <Row
//                     icon={<IconCalendarClock size={18} />}
//                     label="Payment Terms"
//                     value={
//                       merchantData?.paymentTerm?.[0]?.toUpperCase() +
//                       merchantData?.paymentTerm?.slice(1)?.toLowerCase()
//                     }
//                   />
//                   {merchantData?.isNippco && (
//                     <Row
//                       icon={<IconMapPin size={18} />}
//                       label="Coverage Radius"
//                       value={`${merchantData?.radius} km`}
//                     />
//                   )}
//                 </InfoBlock>

//                 <InfoBlock
//                   title="Warehouse Location"
//                   className="grid grid-cols-2 gap-4 space-y-0"
//                 >
//                   <Row
//                     icon={<IconFlag size={18} />}
//                     label="Country"
//                     value={merchantData?.country}
//                   />
//                   <Row
//                     icon={<IconBuildingCastle size={18} />}
//                     label="City"
//                     value={merchantData?.city}
//                   />
//                   <Row
//                     icon={<IconMapPin size={18} />}
//                     label="District"
//                     value={merchantData?.district}
//                   />

//                   <Row
//                     icon={<IconHome2 size={18} />}
//                     label="Short Address"
//                     value={merchantData?.shortAddress}
//                   />
//                   <Row
//                     className="col-span-2"
//                     icon={<IconMapPin size={18} />}
//                     label="Address"
//                     value={merchantData?.location}
//                   />
//                 </InfoBlock>

//                 <InfoBlock
//                   title="Merchant Office Location"
//                   className="grid grid-cols-2 gap-4 space-y-0"
//                 >
//                   <Row
//                     icon={<IconFlag size={18} />}
//                     label="Country"
//                     value={merchantData?.merchantCountry}
//                   />
//                   <Row
//                     icon={<IconBuildingCastle size={18} />}
//                     label="City"
//                     value={merchantData?.merchantCity}
//                   />
//                   <Row
//                     icon={<IconMapPin size={18} />}
//                     label="District"
//                     value={merchantData?.merchantDistrict}
//                   />

//                   <Row
//                     icon={<IconHome2 size={18} />}
//                     label="Short Address"
//                     value={merchantData?.merchantShortAddress}
//                   />
//                   <Row
//                     className="col-span-2"
//                     icon={<IconMapPin size={18} />}
//                     label="Address"
//                     value={merchantData?.merchantFullAddress}
//                   />
//                 </InfoBlock>
//                 <InfoBlock title="Documents">
//                   <Row
//                     label="Start Date"
//                     value={formatDate(merchantData?.contractDate)}
//                     icon2={
//                       <IconCloudDown
//                         onClick={() => {
//                           const url = merchantData.contractDocument;
//                           const link = document.createElement("a");
//                           link.href = url;
//                           link.target = "_blank";
//                           link.download = "";
//                           document.body.appendChild(link);
//                           link.click();
//                           document.body.removeChild(link);
//                         }}
//                         size={18}
//                       />
//                     }
//                   />
//                   <Row
//                     label="VAT Number"
//                     value={merchantData?.vatNumber || ""}
//                     icon2={
//                       <IconCloudDown
//                         onClick={() => {
//                           const url = merchantData.vatDocument;
//                           const link = document.createElement("a");
//                           link.href = url;
//                           link.target = "_blank";
//                           link.download = "";
//                           document.body.appendChild(link);
//                           link.click();
//                           document.body.removeChild(link);
//                         }}
//                         size={18}
//                       />
//                     }
//                   />
//                   <Row
//                     label="Cr Number"
//                     value={merchantData?.crNumber || ""}
//                     icon2={
//                       <IconCloudDown
//                         onClick={() => {
//                           const url = merchantData.crCopy;
//                           const link = document.createElement("a");
//                           link.href = url;
//                           link.target = "_blank";
//                           link.download = "";
//                           document.body.appendChild(link);
//                           link.click();
//                           document.body.removeChild(link);
//                         }}
//                         size={18}
//                       />
//                     }
//                   />
//                   <Row
//                     label="National ID"
//                     value={merchantData?.nationalId || ""}
//                     icon2={
//                       <IconCloudDown
//                         onClick={() => {
//                           const url = merchantData.nationalCopy;
//                           const link = document.createElement("a");
//                           link.href = url;
//                           link.target = "_blank";
//                           link.download = "";
//                           document.body.appendChild(link);
//                           link.click();
//                           document.body.removeChild(link);
//                         }}
//                         size={18}
//                       />
//                     }
//                   />
//                 </InfoBlock>

//                 <InfoBlock
//                   title="Channels"
//                   className="grid grid-cols-2 gap-4 space-y-0"
//                 >
//                   <Row
//                     onClick={() => setChannelModal("sales")}
//                     icon={<IconReportAnalytics size={18} />}
//                     label="Sales Channels"
//                     value={salesChannels?.length || 0}
//                   />

//                   <Row
//                     onClick={() => setChannelModal("shipping")}
//                     icon={<IconShoppingCartCopy size={18} />}
//                     label="Shipping Channels"
//                     value={shippingChannels?.length || 0}
//                   />
//                 </InfoBlock>
//               </div>
//             </div>
//           </div>
//         )}
//       </NewCommonModal>
//       {permissionModal && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
//           <div className="animate-fadeIn bg-[#F7F6F2] rounded-3xl w-[500px] max-h-[76vh] flex flex-col overflow-hidden">
//             <div className="flex items-center justify-between px-4 py-3 border-b">
//               <h2 className="text-lg font-medium text-[#212121]">
//                 Role Permissions
//               </h2>
//               <button
//                 onClick={() => setPermissionModal(false)}
//                 className="p-2 rounded-full border border-[#D2D2D2]"
//               >
//                 <IconX size={20} />
//               </button>
//             </div>

//             <div className="px-4 py-3">
//               <NormalSearch
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//             </div>

//             <div className="flex-1 overflow-y-auto hide-scrollbar px-4 pb-4 space-y-2">
//               <div className="flex items-start gap-3 py-2 border-b last:border-none">
//                 <span className="h-8 w-8 flex justify-center items-center text-[#212121]/70 rounded-full border border-[#D2D2D2]">
//                   1
//                 </span>

//                 <div className="flex flex-col">
//                   <p className="text-[#000000] text-sm font-medium">
//                     dashboard
//                   </p>
//                   <p className="text-gray-500 text-xs"></p>
//                 </div>
//               </div>
//               {/* {filteredPermissions.length > 0 ? (
//                 filteredPermissions.map((permission: any, index: number) => (
//                 ))
//               ) : (
//                 <NoDataFound title="No Permissions Found" message="" />
//               )} */}
//             </div>
//           </div>
//         </div>
//       )}

//       {channelModal && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
//           <div className="bg-[#F7F6F2] rounded-3xl w-[500px] max-h-[70vh] flex flex-col overflow-hidden">
//             {/* Header */}
//             <div className="flex items-center justify-between px-4 py-3 border-b">
//               <h2 className="text-lg font-medium text-[#212121]">
//                 {channelModal === "sales"
//                   ? "Sales Channels"
//                   : "Shipping Channels"}
//               </h2>
//               <button
//                 onClick={() => setChannelModal(null)}
//                 className="p-2 rounded-full border"
//               >
//                 <IconX size={18} />
//               </button>
//             </div>

//             {/* Content */}
//             <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3">
//               {(channelModal === "sales" ? salesChannels : shippingChannels)
//                 ?.length > 0 ? (
//                 (channelModal === "sales"
//                   ? salesChannels
//                   : shippingChannels
//                 ).map((item: any, i: number) => (
//                   <div
//                     key={i}
//                     className="flex items-center gap-3 p-2 rounded-lg hover:bg-[#EFECE4]"
//                   >
//                     {item?.companyLogo && (
//                       <img
//                         alt={item.companyName}
//                         src={item.companyLogo}
//                         className="w-8 h-8 rounded"
//                       />
//                     )}
//                     <p className="text-sm font-medium">{item?.companyName}</p>
//                   </div>
//                 ))
//               ) : (
//                 <div className="flex flex-col items-center justify-center py-10 text-gray-500">
//                   <IconBox size={28} />
//                   <p className="text-sm mt-2">No Channels Connected</p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  IconBox,
  IconBuilding,
  IconBuildingCastle,
  IconBuildingStore,
  IconBuildingWarehouse,
  IconCalendar,
  IconCalendarClock,
  IconChecks,
  IconCloudDown,
  IconContract,
  IconCopy,
  IconEdit,
  IconFlag,
  IconHome2,
  IconId,
  IconKey,
  IconMail,
  IconMapPin,
  IconPhone,
  IconReportAnalytics,
  IconShoppingCartCopy,
  IconUserCheck,
  IconX,
  IconFile,
} from "@tabler/icons-react";

import { useForm } from "react-hook-form";
import formatDate, { maskedSecretKey } from "../../../utilities/helper";
import toast from "react-hot-toast";
import { usePermission } from "../../../hooks/usePermissionTabs";
import AddMerchantModal from "./AddMerchantModal";
import {
  useFetchMerchantSingleData,
  useMerchantUpdateMutation,
} from "../../../apis/merchantApis";
import { useSalesAllIntegrationData } from "../../../apis/integrationApis";
import { use3PLListData } from "../../../apis/3plApis";
import { T, useLanguage } from "../../../context/LanguageContext";

type Props = {
  id: string;
  open: boolean;
  onClose: () => void;
  refetchList?: () => void;
};

type FormValues = {
  id?: string;
  name: string;
  mobileNo: string;
  email: string;
  clientId?: string;
  secretKey?: string;
  contactType: string;
  vatNumber: string;
  nationalId: string;
  nationalCopy: string;
  crNumber: string;
  warehouse: string;
  contactPerson: string;
  district: string;
  city: string;
  paymentTerm: string;
  access: string;
  clientType: string;
  location: string;
  status?: string;
  contractDate: Date;
  vatDocument: File | undefined;
  companyLogo: File | undefined;
  crCopy: File | undefined;
  contractDocument: File | undefined;
};

const TabButton = ({
  active,
  onClick,
  icon,
  label,
  badge,
}: {
  active: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
  badge?: number;
}) => (
  <button
    onClick={onClick}
    className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-all flex items-center gap-1.5 ${
      active
        ? "bg-[#FBD037]/20  text-[#000000] shadow-sm border"
        : "bg-slate-100 text-slate-600 border"
    }`}
  >
    {icon}
    <T>{label}</T>
    {badge !== undefined && badge > 0 && (
      <span className="ml-1 px-1.5 py-0.5 text-[10px] bg-blue-100 text-blue-600 rounded-full">
        {badge}
      </span>
    )}
  </button>
);

const Row = ({
  icon,
  label,
  value,
  icon2,
  className,
}: {
  icon?: React.ReactNode;
  icon2?: React.ReactNode;
  label: string;
  className?: string;
  value: React.ReactNode;
}) => (
  <div className={`flex items-center justify-between gap-2 ${className}`}>
    <div className="flex items-center gap-1.5">
      {icon && <div className="mt-0.5 text-gray-500 scale-90">{icon}</div>}
      <span className="font-medium text-xs text-[#212121]"><T>{label}</T>: </span>
    </div>
    <div className="flex items-center gap-1.5">
      <span className="break-all text-xs">{value}</span>
      {icon2 && <div className="mt-0.5 text-gray-500 scale-90">{icon2}</div>}
    </div>
  </div>
);

const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => (
  <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
    <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
      <Icon size={16} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      <T>{title}</T>
    </p>
  </div>
);

export default function ViewMerchantModal({
  id,
  open,
  onClose,
  refetchList,
}: Props) {
  const { t } = useLanguage();
  const {
    data: merchantData,
    refetch: fetchMerchantData,
    isFetching,
  } = useFetchMerchantSingleData(id);
  const [copied, setCopied] = useState(false);
  const { mutate, isPending } = useMerchantUpdateMutation(merchantData?.id);
  const { data: salesChannels } = useSalesAllIntegrationData();
  const { data: shippingChannels } = use3PLListData();

  const [selectedDocument, setSelectedDocument] = useState<any>({
    crCopy: false,
    companyLogo: false,
    vatDocument: false,
    contractDocument: false,
    nationalCopy: false,
  });
  const [editDialog, setEditDialog] = useState(false);
  const [allIds, setAllIds] = useState<any>();
  const [activeTab, setActiveTab] = useState("company");

  const { allowed: canUpdateClient, isLoading } = usePermission(
    "clients",
    "update",
  );

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    clearErrors,
    control,
    reset,
    formState: { errors },
  } = useForm<any>();

  useEffect(() => {
    if (open && id) {
      fetchMerchantData();
    }
  }, [open, id]);

  useEffect(() => {
    if (editDialog && merchantData) {
      reset(merchantData);
    }
  }, [editDialog, merchantData]);

  const getIds = (data: any) => {
    setAllIds(data);
  };

  const [credential, setCredential] = useState<boolean>(false);
  const credentialToggleModal = () => {
    setCredential(!credential);
    if (!credential) {
      reset();
    }
  };

  const handleUpdate = (data: FormValues) => {
    let {
      clientId,
      secretKey,
      crCopy,
      companyLogo,
      contractDocument,
      vatDocument,
      nationalCopy,
      ...otherData
    } = data;

    mutate(
      {
        ...otherData,
        ...(selectedDocument?.crCopy && { crCopy: crCopy }),
        ...(selectedDocument?.vatDocument && { vatDocument: vatDocument }),
        ...(watch("vatDocument") && { vatDocumentAvailabel: true }),
        ...(watch("nationalCopy") && { NationalIdAvailabel: true }),
        ...(watch("crCopy") && { crCopyAvailabel: true }),
        ...(watch("contractDocument") && { contractDocumentAvailabel: true }),
        ...(selectedDocument?.companyLogo && { companyLogo: companyLogo }),
        ...(selectedDocument?.nationalCopy && { nationalCopy: nationalCopy }),
        ...(selectedDocument?.contractDocument && {
          contractDocument: contractDocument,
        }),
        ...allIds,
      },
      {
        onSuccess: () => {
          setSelectedDocument({
            crCopy: false,
            companyLogo: false,
            vatDocument: false,
            contractDocument: false,
            nationalCopy: false,
          });
          credentialToggleModal();
          setEditDialog(false);
          fetchMerchantData();
          refetchList?.();
          toast.success("Merchant Update successfully!");
        },
        onError: (error: any) => {
          const errorMessage =
            error?.response?.data?.error?.message ||
            error?.response?.data?.message ||
            error?.message ||
            (typeof error === "string" ? error : null) ||
            "Failed to Update Merchant";

          toast.error(errorMessage);
        },
      },
    );
  };

  const handleCopy = async (text?: string) => {
    if (!text) return;

    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 1500);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  const smartEmail = (email?: string) => {
    if (!email) return "";

    const [name, domain] = email.split("@");
    if (!domain) return email;

    const [domainName, extension] = domain.split(".");

    const shortName = name.length > 5 ? `${name.slice(0, 4)}...` : name;

    const shortDomain =
      domainName && domainName.length > 4
        ? `${domainName.slice(0, 3)}...`
        : domainName;

    return `${shortName}@${shortDomain}.${extension || ""}`;
  };

  if (!open) return null;

  return (
    <div className="relative rounded-3xl shadow-sm border flex flex-col overflow-hidden bg-white">
      {/* Modal Header */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200  ">
        <div className="flex items-center gap-2">
          <div className="w-14 h-14 rounded-xl overflow-hidden">
            <img
              src={merchantData?.companyLogo || "/img/dummy-logo.png"}
              alt="Merchant Logo"
              className="w-full h-full object-cover rounded-xl"
            />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-[#212121]">
              {merchantData?.name}
            </h2>
            <p className="text-sm text-[#212121]/70">
              ID: {merchantData?.clientId}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          {!editDialog && canUpdateClient && (
            <button
              onClick={() => setEditDialog(true)}
              className="p-2 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors"
              title={t("Edit Merchant")}
            >
              <IconEdit size={18} />
            </button>
          )}
          {editDialog && (
            <button
              onClick={handleSubmit(handleUpdate)}
              disabled={isPending}
              className="px-4 py-2 bg-[#FBD037] text-[#212121] rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isPending ? t("Updating...") : t("Update")}
            </button>
          )}
          <button
            onClick={() => {
              setEditDialog(false);
              onClose();
            }}
            className="p-2 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors"
          >
            <IconX size={20} />
          </button>
        </div>
      </div>

      {/* Modal Body */}
      <div className="flex-1 overflow-y-auto hide-scrollbar">
        {isFetching ? (
          <div className="w-full space-y-4 p-10 text-center">
            <div className="animate-pulse">{t("Loading...")}</div>
          </div>
        ) : editDialog ? (
          <div className="py-2">
            <AddMerchantModal
              register={register}
              errors={errors}
              clearErrors={clearErrors}
              setValue={setValue}
              control={control}
              getIds={getIds}
              watch={watch}
              setSelectedDocument={setSelectedDocument}
              merchantData={merchantData}
            />
          </div>
        ) : (
          <div className="relative p-4">
            {/* Tabs */}
            <div className="flex gap-2 mb-4 border-b border-gray-200/50 pb-2">
              <TabButton
                active={activeTab === "company"}
                onClick={() => setActiveTab("company")}
                icon={<IconBuilding size={14} />}
                label="Company Info"
              />
              <TabButton
                active={activeTab === "locations"}
                onClick={() => setActiveTab("locations")}
                icon={<IconMapPin size={14} />}
                label="Locations"
              />
              <TabButton
                active={activeTab === "documents"}
                onClick={() => setActiveTab("documents")}
                icon={<IconFile size={14} />}
                label="Documents"
              />
              <TabButton
                active={activeTab === "channels"}
                onClick={() => setActiveTab("channels")}
                icon={<IconReportAnalytics size={14} />}
                label="Channels"
                badge={
                  (salesChannels?.length || 0) + (shippingChannels?.length || 0)
                }
              />
            </div>

            {/* Company Info Tab */}
            {activeTab === "company" && (
              <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
                <SectionHeader
                  icon={IconBuilding}
                  title="Company Information"
                />
                <div className="space-y-2">
                  <div className="flex flex-wrap items-center justify-between">
                    <div className="flex items-center gap-1.5">
                      <IconId size={16} className="text-gray-500" />
                      <span className="font-medium text-xs text-[#212121]">
                        <T>Merchant ID</T> :
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="break-all text-xs">
                        {merchantData?.clientId}
                      </span>
                      <div
                        onClick={() => handleCopy(merchantData?.clientId)}
                        className="cursor-pointer"
                      >
                        {copied ? (
                          <IconChecks size={16} className="text-green-600" />
                        ) : (
                          <IconCopy size={16} className="text-gray-500" />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* <Row
                    icon={<IconBuilding size={16} />}
                    label="Status"
                    value={
                      <span
                        className={`inline-flex px-2 py-0.5 text-xs rounded-full ${
                          merchantData?.status === "ACTIVE"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-600"
                        }`}
                      >
                        {merchantData?.status}
                      </span>
                    }
                  /> */}

                  <div className="flex flex-wrap items-center justify-between">
                    <div className="flex items-center gap-1.5">
                      <IconKey size={16} className="text-gray-500" />
                      <span className="font-medium text-xs text-[#212121]">
                        <T>Secret Key</T> :
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="break-all text-xs">
                        {maskedSecretKey(merchantData?.secretKey)}
                      </span>
                      <div
                        onClick={() => handleCopy(merchantData?.secretKey)}
                        className="cursor-pointer"
                      >
                        {copied ? (
                          <IconChecks size={16} className="text-green-600" />
                        ) : (
                          <IconCopy size={16} className="text-gray-500" />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-wrap items-center justify-between">
                    <div className="flex items-center gap-1.5">
                      <IconMail size={16} className="text-gray-500" />
                      <span className="font-medium text-xs text-[#212121]">
                        <T>Email</T> :
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="break-all text-xs">
                        {smartEmail(merchantData?.email)}
                      </span>
                      <div
                        onClick={() => handleCopy(merchantData?.email)}
                        className="cursor-pointer"
                      >
                        {copied ? (
                          <IconChecks size={16} className="text-green-600" />
                        ) : (
                          <IconCopy size={16} className="text-gray-500" />
                        )}
                      </div>
                    </div>
                  </div>

                  <Row
                    icon={<IconPhone size={16} />}
                    label="Mobile"
                    value={merchantData?.mobileNo}
                  />
                  <Row
                    icon={<IconUserCheck size={16} />}
                    label="Access"
                    value={merchantData?.access}
                  />
                  <Row
                    icon={<IconCalendar size={16} />}
                    label="Joined"
                    value={formatDate(merchantData?.createdAt)}
                  />
                  <Row
                    icon={<IconContract size={16} />}
                    label="Contact Person"
                    value={merchantData?.contactPerson || "-"}
                  />
                  <Row
                    icon={<IconCalendarClock size={16} />}
                    label="Payment Terms"
                    value={
                      merchantData?.paymentTerm?.[0]?.toUpperCase() +
                      merchantData?.paymentTerm?.slice(1)?.toLowerCase()
                    }
                  />
                  <Row
                    icon={<IconBuildingStore size={16} />}
                    label="Warehouse"
                    value={merchantData?.warehouseName || "-"}
                  />
                  {merchantData?.isNippco && (
                    <Row
                      icon={<IconMapPin size={16} />}
                      label="Coverage Radius"
                      value={`${merchantData?.radius} km`}
                    />
                  )}
                </div>
              </div>
            )}

            {/* Locations Tab (Combined Warehouse + Office) */}
            {activeTab === "locations" && (
              <div className="space-y-4">
                {/* Warehouse Location Section */}
                <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                  <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
                  <SectionHeader
                    icon={IconBuildingWarehouse}
                    title="Warehouse Location"
                  />
                  <div className="space-y-2">
                    <Row
                      icon={<IconFlag size={16} />}
                      label="Country"
                      value={merchantData?.country || "-"}
                    />
                    <Row
                      icon={<IconBuildingCastle size={16} />}
                      label="City"
                      value={merchantData?.city || "-"}
                    />
                    <Row
                      icon={<IconMapPin size={16} />}
                      label="District"
                      value={merchantData?.district || "-"}
                    />
                    <Row
                      icon={<IconHome2 size={16} />}
                      label="Short Address"
                      value={merchantData?.shortAddress || "-"}
                    />
                    <Row
                      icon={<IconMapPin size={16} />}
                      label="Address"
                      value={merchantData?.location || "-"}
                    />
                  </div>
                </div>

                {/* Merchant Office Location Section */}
                <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                  <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
                  <SectionHeader
                    icon={IconBuildingCastle}
                    title="Merchant Office Location"
                  />
                  <div className="space-y-2">
                    <Row
                      icon={<IconFlag size={16} />}
                      label="Country"
                      value={
                        merchantData?.merchantCountry ||
                        merchantData?.country ||
                        "-"
                      }
                    />
                    <Row
                      icon={<IconBuildingCastle size={16} />}
                      label="City"
                      value={
                        merchantData?.merchantCity ||
                        merchantData?.city ||
                        "-"
                      }
                    />
                    <Row
                      icon={<IconMapPin size={16} />}
                      label="District"
                      value={
                        merchantData?.merchantDistrict ||
                        merchantData?.district ||
                        "-"
                      }
                    />
                    <Row
                      icon={<IconHome2 size={16} />}
                      label="Short Address"
                      value={
                        merchantData?.merchantShortAddress ||
                        merchantData?.shortAddress ||
                        "-"
                      }
                    />
                    <Row
                      icon={<IconMapPin size={16} />}
                      label="Address"
                      value={
                        merchantData?.merchantFullAddress ||
                        merchantData?.location ||
                        "-"
                      }
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Documents Tab */}
            {activeTab === "documents" && (
              <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
                <SectionHeader icon={IconFile} title="Documents" />
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1.5">
                      <IconCalendar size={16} className="text-gray-500" />
                      <span className="font-medium text-xs text-[#212121]">
                        <T>Contract Date</T> :
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="text-xs">
                        {formatDate(merchantData?.contractDate)}
                      </span>
                      {merchantData?.contractDocument && (
                        <a
                          onClick={() =>
                            window.open(
                              merchantData?.contractDocument,
                              "_blank",
                            )
                          }
                          className="cursor-pointer"
                        >
                          <IconCloudDown
                            size={16}
                            className="text-gray-500 hover:text-yellow-600"
                          />
                        </a>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center justify-between border-t pt-2 border-gray-100/50">
                    <div className="flex items-center gap-1.5">
                      <IconFile size={16} className="text-gray-500" />
                      <span className="font-medium text-xs text-[#212121]">
                        <T>VAT Number</T> :
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="text-xs">
                        {merchantData?.vatNumber || "-"}
                      </span>
                      {merchantData?.vatDocument && (
                        <a
                          onClick={() =>
                            window.open(merchantData?.vatDocument, "_blank")
                          }
                          className="cursor-pointer"
                        >
                          <IconCloudDown
                            size={16}
                            className="text-gray-500 hover:text-yellow-600"
                          />
                        </a>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center justify-between border-t pt-2 border-gray-100/50">
                    <div className="flex items-center gap-1.5">
                      <IconFile size={16} className="text-gray-500" />
                      <span className="font-medium text-xs text-[#212121]">
                        <T>CR Number</T> :
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="text-xs">
                        {merchantData?.crNumber || "-"}
                      </span>
                      {merchantData?.crCopy && (
                        <a
                          onClick={() =>
                            window.open(merchantData?.crCopy, "_blank")
                          }
                          className="cursor-pointer"
                        >
                          <IconCloudDown
                            size={16}
                            className="text-gray-500 hover:text-yellow-600"
                          />
                        </a>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center justify-between border-t pt-2 border-gray-100/50">
                    <div className="flex items-center gap-1.5">
                      <IconId size={16} className="text-gray-500" />
                      <span className="font-medium text-xs text-[#212121]">
                        <T>National ID</T> :
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="text-xs">
                        {merchantData?.nationalId || "-"}
                      </span>
                      {merchantData?.nationalCopy && (
                        <a
                          onClick={() =>
                            window.open(merchantData?.nationalCopy, "_blank")
                          }
                          className="cursor-pointer"
                        >
                          <IconCloudDown
                            size={16}
                            className="text-gray-500 hover:text-yellow-600"
                          />
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Channels Tab - Direct list without modal */}
            {activeTab === "channels" && (
              <div className="space-y-4">
                <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                  <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
                  <SectionHeader
                    icon={IconReportAnalytics}
                    title="Sales Channel"
                  />
                  {salesChannels?.length > 0 ? (
                    <div className="grid grid-cols-2 gap-2">
                      {salesChannels.map((channel: any, idx: number) => (
                        <div
                          key={idx}
                          className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                        >
                          {channel?.companyLogo && (
                            <img
                              alt={channel.companyName}
                              src={channel.companyLogo}
                              className="w-7 h-7 rounded"
                            />
                          )}
                          <span className="text-gray-700 font-medium text-xs">
                            {channel.companyName}
                          </span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-6 text-gray-400">
                      <IconBox size={24} className="mx-auto mb-2 opacity-30" />
                      <p className="text-xs"><T>No sales channels assigned</T></p>
                    </div>
                  )}
                </div>

                <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                  <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
                  <SectionHeader
                    icon={IconShoppingCartCopy}
                    title="Shopping Channels"
                  />
                  {shippingChannels?.length > 0 ? (
                    <div className="grid grid-cols-2 gap-2">
                      {shippingChannels.map((channel: any, idx: number) => (
                        <div
                          key={idx}
                          className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                        >
                          {channel?.companyLogo && (
                            <img
                              alt={channel.companyName}
                              src={channel.companyLogo}
                              className="w-7 h-7 rounded"
                            />
                          )}
                          <span className="text-gray-700 font-medium text-xs">
                            {channel.companyName}
                          </span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-6 text-gray-400">
                      <IconBox size={24} className="mx-auto mb-2 opacity-30" />
                      <p className="text-xs"><T>No shipping channels assigned</T></p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
